import { Card } from "react-bootstrap";

export default function PcWin11() {
    return (
        <div>
            <Card.Title>How to install skeld.net on PC (Windows 11)</Card.Title>
            <Card.Text style={{ fontSize: "1em" }}>
                <ol>
                    <li>Make sure you have Among Us installed</li>
                    <li>Run Among Us, then close it</li>
                    <li>
                        Run this command in PowerShell:
                        <br />
                        Invoke-WebRequest -URI
                        "https://api.skeld.net/regionInfo" -Method Get -OutFile
                        "$env:APPDATA\..\LocalLow\Innersloth\Among
                        Us\regionInfo.json"
                    </li>
                    <li>Launch Among Us</li>
                    <li>Change your region to skeld.net</li>
                </ol>
            </Card.Text>
        </div>
    );
}
